<!--
 * @文件描述: 
 * @公司: thundersdata
 * @作者: 杜若水
 * @Date: 2019-10-15 09:11:11
 * @LastEditors: 杜若水
 * @LastEditTime: 2019-10-24 10:04:13
 -->
<template>
  <el-dialog title="选择产品" width="800px" class="cellDialog table-prize" :visible.sync="visible" @close="handleClose"
    @open="handleOpen">
    <el-form :inline="true" :model="searchParams" style="margin:18px 0 10px">
      <el-form-item label="产品编号" class="item-el-from">
        <el-input v-model="searchParams.productCode" placeholder="请输入产品编号" clearable class="table-prize-input">
        </el-input>
      </el-form-item>
      <el-form-item label="产品名称" class="item-el-from">
        <el-input v-model="searchParams.productName" placeholder="请输入产品名称" class="table-prize-input" clearable>
        </el-input>
      </el-form-item>
      <el-form-item class="last-item-el-from">
        <el-button type="primary" @click="handleSearch">查询</el-button>
      </el-form-item>
    </el-form>
    <el-table border :data="tableData" current-row-key="productCode" ref="table"
      @selection-change="handleSelectionChange" class="table">
      <el-table-column type="selection" width="55">
      </el-table-column>
      <el-table-column property="productCategoryName" label="产品类别" width="120"></el-table-column>
      <el-table-column property="productCode" label="产品编号" width="120"></el-table-column>
      <el-table-column property="productName" label="产品名称"></el-table-column>
      <el-table-column property="productSpec" label="包装规格" width="100"></el-table-column>
    </el-table>
    <div class="table-foot table-prize-footer" style="margin-top: 20px">
      <span>本次已选数量：
        <span style="color:green;font-weight:bold">{{hasSelectedCount}}</span>条</span>
      <el-pagination class="table-foot-pagination" background @size-change="handleSizeChange"
        @current-change="handleCurrentChange" :page-size="limit" layout="total, prev, pager, next, jumper"
        :total="totalCount">
      </el-pagination>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="handleClose" class="dialog-footer-cancel">取 消</el-button>
      <el-button type="primary" @click="handleSubmit">确 定</el-button>
    </span>
  </el-dialog>
</template>
<script>
import { getProductList } from '@/api/cardTicket.js'
import { FIRST_PAGE, LIMIT, SUCCESS_CODE } from './constant'
import { mapMutations } from 'vuex'
export default {
  props: {
    dialogVisible: {
      type: Boolean,
      default () {
        return false
      }
    },
    allMultipleSelection: {
      type: Array,
      default () {
        return []
      }
    },
    // 是否清空已经选择的产品列表 默认不清空，当进入新增页面的时候，清空
    isClear: {
      type: Boolean,
      default () {
        return false
      }
    }
  },

  watch: {
    dialogVisible: {
      handler (val) {
        this.visible = val
      },
      immediate: true,
      deep: true
    },

    allMultipleSelection: {
      handler (val) {
        this.multipleSelectionAll = val
      },
      immediate: true,
      deep: true
    },
    // isClear是否清除vuex里面选择的产品名称列表  
    // 当点击新增按钮时清除，其他时候不清除  
    // isClear这个参数只在新增的时候传进来
    isClear: {
      handler (val) {
        if (val) {
          this.EXCHANGE_SELECTED([])
        }
      },
      immediate: true,
      deep: true
    }
  },

  data () {
    return {
      tableData: [],
      totalCount: null, // 总页数
      limit: LIMIT, // 每页请求几条数据
      visible: false,
      multipleSelection: [], // 选中的当前页的数据
      multipleSelectionAll: [], // 所有选中的列表数据
      idKey: 'productCode', // 标识列表数据中每一行的唯一键的名称
      activityId: this.$route.query.activityid,
      searchParams: {
        page: FIRST_PAGE,
        limit: LIMIT,
        productCode: null,
        productName: null,
        activityId: this.$route.query.activityid
      },
      allSelected: [], // 所有选中的productCode
      hasSelectedCount: null // 本次已选数量
    }
  },
  created () {
    this.fetchProductList()
  },

  methods: {
    ...mapMutations(['EXCHANGE_SELECTED']),
    // 获取产品 列表
    fetchProductList () {
      getProductList(this.searchParams).then(res => {
        if (res.data.code === '200') {
          const { list, total } = res.data.result

          this.tableData = list.map(item => {
            item.productCode = item.productCode
            return item
          })
          this.totalCount = total
          this.toggleSelection()
        }
      })
    },

    // 关闭弹窗
    handleClose (done) {
      this.$emit('handleProductClose')
    },

    // 打开弹窗 时 清空选中状态 产品说不需要清空状态
    handleOpen () {
      // 获取所有选中的数据
      this.multipleSelectionAll = this.$store.state.multipleSelectionAll
      // 获取所有选中的productCode
      this.allSelected = this.multipleSelectionAll.map(item => +item.productCode)
      // 本次已选数量
      this.hasSelectedCount = this.allSelected.length
      // 回显到页面上
      this.$nextTick(() => {
        const list = this.tableData.filter(item => {
          return this.allSelected.includes(item.productCode)
        })
        this.$refs.table.clearSelection()
        list.forEach(item => {
          this.$refs.table.toggleRowSelection(item, true)
        })
      })
    },

    //搜索时查询产品名称
    handleSearch () {
      // 有搜索条件时，从第一页开始查询
      this.searchParams.page = FIRST_PAGE
      this.fetchProductList()
    },

    // 点击复选框时  存储 选择的数据
    handleSelectionChange (val) {
      setTimeout(() => {
        // 当前选中
        const selected = val.map(item => +item.productCode)
        // 合并原有和当前选中
        const allSelected = this.allSelected.concat(selected)
        // 去除重复数据
        this.allSelected = [...new Set(allSelected)]

        // 没有选中的列表 中的 productCode 组成的数组
        const noSelected = this.tableData.filter(item => !selected.includes(item.productCode)).map(item => +item.productCode)

        // 去除 取消选中的数据
        const list = JSON.parse(JSON.stringify(this.allSelected))
        this.allSelected = list.filter(item => !noSelected.includes(item))
        //合并原有和当前选中
        const proList = this.multipleSelectionAll.concat(val)
        //去除重复数据
        const obj = {}
        const newProList = proList.reduce((cur, next) => {
          obj[next.productCode] ? '' : obj[next.productCode] = true && cur.push(next)
          return cur
        }, [])
        // 没有选中的列表
        const noSelectedList = this.tableData.filter(item => noSelected.includes(item.productCode))

        // 去除取消选中的数据
        this.multipleSelectionAll = newProList.filter(item => !noSelectedList.some(ele => +item.productCode === +ele.productCode))

        // 本次已选数量
        this.hasSelectedCount = this.multipleSelectionAll.length
      }, 10)
    },


    // 点击确认按钮 把数据传给父级
    handleSubmit () {
      this.EXCHANGE_SELECTED(this.multipleSelectionAll)
      this.$emit('handleChoosedProduct')
    },

    handleSizeChange (page) {
      this.searchParams.page = page
    },

    // 分页
    handleCurrentChange (page) {
      this.searchParams.page = page
      this.fetchProductList()
    },

    toggleSelection () {
      // 选中数据为空时，直接返回
      if (this.allSelected.length === 0) {
        return
      }
      this.$nextTick(() => {
        const list = this.tableData.filter(item => {
          // 排除取本页已选中的数据，即获取选中的
          return this.allSelected.some(productCode => productCode === item.productCode)
        })
        list.forEach(item => {
          this.$refs.table.toggleRowSelection(item)
        })
      })
    },
  }
}
</script>
<style lang="css" scoped>
.prize-dialog-table-foot .table-foot-pagination {
  margin-top: 10px;
}
.item-el-from {
  margin-right: 40px;
}
.acivity-content-form {
  padding-top: 0;
}
</style>